export const addRandomBorderColor = () => {
    const colors = [
      "#168aad",
      "#f15bb5",
      "#081299",
      "#248277",
      "#ba181b",
      "#ffbe0b",
      "#fb5607",
      "#ff006e",
      "#8338ec",
      "#3a86ff",
      "#4d194d",
      "#ff002b",
      "#d1ac00",
    ];
    return colors[Math.floor(colors.length*Math.random())]
 }